export const APP_NAMESPACE = process.env.NEXT_PUBLIC_NAMESPACE || ''
export const APP_NAME = process.env.NEXT_PUBLIC_APP_NAME || ''
export const APP_SITEMAP_START_DATE = process.env.APP_SITEMAP_START_DATE || ''
export const APP_HOST = process.env.NEXT_PUBLIC_ORIGIN_HOST || ''
export const APP_DESCRIPTION = process.env.NEXT_PUBLIC_APP_DESCRIPTION || ''
export const APP_PUBLIC_URL = process.env.NEXT_PUBLIC_PUBLIC_URL || ''
export const APP_SERVER_CONTAINER_HOST = process.env.NEXT_PUBLIC_CONTAINER_HOST || ''
export const APP_FACEBOOK_PROFILE = process.env.NEXT_PUBLIC_FACEBOOK_PROFILE || ''
export const APP_TWITTER_PROFILE = process.env.NEXT_PUBLIC_TWITTER_PROFILE || ''
export const APP_GOOGLE_ANALYTICS_ID = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID || ''

export const APP_CONTACT_EMAIL = process.env.NEXT_PUBLIC_APP_CONTACT_EMAIL || ''
export const META_TITLE = process.env.NEXT_PUBLIC_APP_META_TITLE || ''

export const TITLE = process.env.NEXT_PUBLIC_APP_TITLE || ''

export const API_BASE_URL = `${process.env.NEXT_PUBLIC_BE_SERVER_PROTOCOL}://${process.env.NEXT_PUBLIC_BE_SERVER}/api/v1`

export const IMAGES_BASE_URL = process.env.NEXT_PUBLIC_IMAGES_BASE_URL

// export const IMAGES_BASE_URL =
//   process.env.NEXT_PUBLIC_NODE_ENV === 'production'
//     ? `https://api.${APP_NAME}.com/public`
//     : 'http://localhost:5000/public'

// export const ARTICLES_IMAGES_BASE_URL_FOR_SHARE =
//   process.env.NEXT_PUBLIC_NODE_ENV === 'production' ? `${IMAGES_BASE_URL}/articles/original` : APP_PUBLIC_URL

export const ARTICLES_IMAGES_BASE_URL_FOR_SHARE = `${IMAGES_BASE_URL}/articles/original`

/* The REST endpoint to upload image for avatars */
export const AVATARS_BASE_URL = `${IMAGES_BASE_URL}/avatars`

/* The REST endpoint to upload image for articles */
// TODO: Image resizing is not working properly in case of multiple images are uploading, it is overriding the image
// export const ARTICLES_BASE_IMG_URL = `${IMAGES_BASE_URL}/articles/1200xauto`
export const ARTICLES_BASE_IMG_URL = `${IMAGES_BASE_URL}/articles/original`

/* The REST endpoint to upload image from CKEditor */
export const ARTICLES_CONTENT_IMAGE_BASE_URL = `${IMAGES_BASE_URL}/article-contents`

/* The base location from where the images can be fetched */
export const ARTICLES_CONTENT_IMAGE_UPLOAD_URL = `${API_BASE_URL}/articles/news-content-images`
export const ITEMS_PER_PAGE = 6
